import { cn } from "@/lib/utils";

type MetricDeltaProps = {
  value?: number | null;
  digits?: number;
  invert?: boolean;
};

export function MetricDelta({ value, digits = 2, invert = false }: MetricDeltaProps) {
  if (value == null || Number.isNaN(value)) {
    return <span className="text-xs text-muted-foreground">No prior window</span>;
  }

  const effective = invert ? value * -1 : value;
  const direction = effective > 0 ? "up" : effective < 0 ? "down" : "flat";

  return (
    <span
      className={cn(
        "text-xs font-medium",
        direction === "up" && "text-emerald-400",
        direction === "down" && "text-rose-400",
        direction === "flat" && "text-muted-foreground"
      )}
    >
      {direction === "up" ? "+" : ""}
      {effective.toFixed(digits)}%
    </span>
  );
}
